import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from 'helpers/date.js';
import Loading from 'components/Loading';
import { useCompany, useUser } from 'models';
import Axios from 'axios';
import { DebounceInput } from 'react-debounce-input';
import { useHistory } from 'react-router-dom'

import * as elitePass from '../../images/logo/logo_elite_pass.png';
import * as ss_select from '../../images/logo/logo_scansource_select_colorido.png';
import * as elite from '../../images/logo-sm-elite.png';
import * as scancash from '../../images/scancash.png';
import { AdminProfiles } from 'helpers/Enum';

const ResalesList = () => {
  const user = useUser();
  const defaultFilters = {
    search: '',
    per_page: 10,
    page: 1,
    company_type_id: 2,
    __ranking_type: 1,
    sort: 'id',
    sort_dir: 'desc',
    ranking: 1
    //fiscal_year_id: 12,
  };

  const { setCompany } = useCompany()

  const [filters, setFilters] = useState(defaultFilters);
  const [companies, setCompanies] = useState({ data: [] });
  const [pagination, setPagination] = useState({});

  const [pageReturn, setPageReturn] = useState('/');
  const [isLoading, setIsLoading] = useState(false);
  const Data = [];

  useEffect(() => {
    setIsLoading(true);
    if (localStorage.getItem('returnPage') != null) {
      setPageReturn(localStorage.getItem('returnPage'));
      localStorage.removeItem('returnPage');
    }
    let aux_token_cancel_request = Axios.CancelToken.source();
    ResalesRequestService.getAllDetails({
      params: { ...filters },
      cancelToken: aux_token_cancel_request.token
    }).then((data) => {
      setCompanies(data.data);
      setPagination(data.data.pagination);
      setIsLoading(false)
    });

    return () => {
      if (aux_token_cancel_request)
        aux_token_cancel_request.cancel('Não é mais de meu interesse enviar esta requisição.');
    }
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  const buildClassificationLabel = company => {
    if ([0, 2].includes(company.is_premium)) {
      return company.is_premium == 2 ? 'Elite Gerencial' : 'Sem Classificação'
    }

    const getCatLogo = cat => {
      switch (cat) {
        case 1:
          return elite
        case 3:
          return scancash
        case 4:
          return elitePass
        case 5:
          return ss_select
      }

    }

    if (company.date_accept) {
      return (
        <img
          src={getCatLogo(company.is_premium)}
          height={company.is_premium == 4 ? '30' : '25'}
        />
      )
    }
  }

  const renderData = () => {
    var ids = [];
    let model = { id: 0, count: 0 };

    Object.values(companies.data).map((company, k) => {
      var m = null;
      ids = ids.map((a) => {
        if (a.id == company.id) {
          a.count += 1;
          m = a;
        }
        return a;
      });
      if (m == null) {
        m = { ...model };
        m.id = company.id;
        m.count = 1;
        ids.push(m);
      }
      var id = m.id + '-' + m.count;
      var x = company.document.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
      var cnpj = !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');
      const position = company.ranking_position ? company.ranking_position + "º" : "Sem posição"
      Data.push({
        id: id,
        ranking_position: position,
        btn: btn(company.id, company.company_name, company),
        name: company.company_name,
        document: cnpj,
        premium: buildClassificationLabel(company),
        value: company.ranking_value
          ? company.ranking_value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          : '--',
        total_access: company.total_access,
        last_access:
          company.last_access_date != '--'
            ? parseDateBR(company.last_access_date)
            : '--',
      });
    });
  };

  const columns = [
    {
      dataField: 'ranking_position',
      text: '',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
        fontWeight: 'bold'
      },
    },
    {
      dataField: 'premium',
      text: 'Classificação',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'document',
      text: 'CNPJ',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'total_access',
      text: 'Qtd de acessos',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'last_access',
      text: 'Último acesso',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'value',
      text: 'Faturamento Total',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%',
      },
      style: {
        textAlign: 'center',
      },
    },
  ];

  function btn(id, name, company) {
    var btn_id = 'btn-' + id;
    return (
      <Button
        variant="primary"
        className="font-12"
        type="button"
        id={btn_id}
        onClick={() => {
          ResalesRequestService.getResale(company.id, {
            params: {
              embed: "adhesion.fiscalYear,invoicing"
            }
          }).then(async ({ data }) => {
            const { data: selectedCompany } = data
            updateFiscalYear(selectedCompany)
            // await new Promise((resolve) => {
            //   if (selectedCompany.adhesion.length > 0) {
            //     if (AdminProfiles.includes(user.profile.id)) {
            //       const { fiscal_year } = data.data.adhesion[0]
            //       localStorage.setItem("Elite:fiscalYear", JSON.stringify(fiscal_year))
            //     } else {
            //       const { fiscal_year } = data.data.adhesion.filter(item => item.fiscal_year.block !== 1)[0]
            //       localStorage.setItem("Elite:fiscalYear", JSON.stringify(fiscal_year))
            //     }
            //   } else {
            //     const { current_fiscal_year } = selectedCompany
            //     localStorage.setItem("Elite:fiscalYear", JSON.stringify(current_fiscal_year))
            //   }
            //   resolve(true)
            // })
            setCompany(data.data)
            window.location.href = pageReturn;
          })
        }}
      >
        Acessar
      </Button>
    );
  }

  const updateFiscalYear = async (company) => {
    const setFiscalYear = async (fy) => {
      localStorage.setItem('Elite:fiscalYear', JSON.stringify(fy));
    }

    if (company.adhesion.length > 0) {
      const adhesion = AdminProfiles.includes(user.profile.id) 
        ? company.adhesion[0] 
        : company.adhesion.find(year => year.fiscal_year.block !== 1)

        if (adhesion?.fiscal_year) {
          setFiscalYear(adhesion.fiscal_year)
        }
    } else {
      setFiscalYear(company.current_fiscal_year)
    }
  }

  renderData();
  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  return (
    <>
      <Row>
        <Col xs={12} md={4}>
          <Form.Group>
            <Form.Label>Registros por página:</Form.Label>
            <Form.Control
              as="select"
              value={filters.per_page}
              onChange={(e) =>
                handleFilterChange({ per_page: e.target.value, page: 1 })
              }
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Form.Group>
            <Form.Label>Classificação:</Form.Label>
            <Form.Control
              as="select"
              value={filters.elite}
              onChange={(e) =>
                handleFilterChange({ premium: e.target.value, page: 1 })
              }
            >
              <option value="">Todos</option>
              <option value="1">Outros</option>
              <option value="5">ScanSource Select</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col xs={12} md={4}>
          <Form.Group>
            <Form.Label>Pesquisa:</Form.Label>
            <DebounceInput
              element={Form.Control}
              debounceTimeout={500}
              onChange={(e) =>
                handleFilterChange({
                  search: e.target.value,
                  page: 1,
                })
              }
            />
          </Form.Group>
        </Col>
      </Row>
      {isLoading ? (<Loading page />) : (
        <Row className="mt-4">
          <Col className={getTamanho(768) ? "p-0" : ''}>
            <BootstrapTable
              wrapperClasses={getTamanho(940) ? 'table-responsive' : ''}
              style={{ width: '100px' }}
              id="table"
              className="font-10"
              keyField="id"
              data={Data}
              columns={columns}
              striped
              bordered
              hover
              condensed
            />
            <Row className="mt-4">
              <Col md={6} xs={12}>
                <Trans i18nKey="label:interpolateShowingRecords">
                  Showing {{ from: pagination.from || '0' }} to{' '}
                  {{ to: pagination.to || '0' }} from{' '}
                  {{ total: pagination.total }} records
                </Trans>
              </Col>
              <Col className="d-flex justify-content-end" md={6} xs={12}>
                <Pagination
                  activePage={pagination.current_page}
                  itemsCountPerPage={pagination.per_page}
                  totalItemsCount={pagination.total}
                  pageRangeDisplayed={isMobile ? 3 : 5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  prevPageText="‹"
                  nextPageText="›"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ResalesList;
